import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import "./App.css";
import { Toaster } from './components/ui/sonner';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import BrandsSection from './components/BrandsSection';
import StoreSection from './components/StoreSection';
import ServicesSection from './components/ServicesSection';
import GoogleReviewsSection from './components/GoogleReviewsSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import ScrollToTop from './components/ScrollToTop';
import NotFoundPage from './components/NotFoundPage';
import LegalPage from './components/LegalPage';

const HomePage = () => {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <BrandsSection />
        <StoreSection />
        <ServicesSection />
        <GoogleReviewsSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
      <CookieBanner />
      <ScrollToTop />
    </>
  );
};

function App() {
  return (
    <ThemeProvider>
      <div className="App bg-white dark:bg-gray-900 transition-colors duration-300">
        <Toaster position="top-right" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/mentions-legales" element={<LegalPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
